// ** Reactstrap
import { Button, Modal, ModalBody, ModalFooter } from "reactstrap";

import { ComponentSpinner } from "../../spinner";
import CustomAlerts from "@components/ui-components/alerts";
import Flex from "@components/ui-components/flex";
// ** Custom Components
import LoadingButton from "@components/ui-components/loading-button";
// ** Third Party
import classnames from "classnames";
import { useTranslation } from "react-i18next";

const CommonModal = props => {
    const {
        title = "",
        handleModal,
        isOpen,
        body = null,
        type = "small",
        confirmButton = {
            disabled : false,
            color    : "primary",
            txt      : "",
            showOnTop: false,
            onClick  : () => {},
            loading  : false
        },
        loading = false,
        modalColor = "secondary",
        titleIcon = "",
        extraFooterItems = <></>,
        isDirty = false,
        subject = "",
        action = "",
        modalBodyClassName = "",
        backdrop = false,
        hideClose = false,
        extraHeader = <></>
    } = props;

    const modalClass = {
        extraSmall: "modal-xs",
        small     : "modal-sm",
        medium    : "modal-md",
        extraLarge: "modal-xl",
        fullScreen: "modal-fullscreen",
        large     : "modal-lg"
    };
    const { t } = useTranslation();
    
    return (
        <Modal
            data-cy="modal"
            modalClassName={`modal-${modalColor}`}
            isOpen={isOpen}
            backdrop={backdrop}
            keyboard={false}
            toggle={() => handleModal()}
            className={classnames("modal-dialog-centered", modalClass[type])}>
            <div data-cy="modal-header" className={classnames("modal-header d-flex flex-wrap justify-content-center justify-content-sm-between", {
                "border-bottom": !hideClose || title
            })}>
                <div className="font-medium-2 fw-bolder" data-cy="modal-title">
                    {titleIcon ? <i className={`mdi mdi-${titleIcon} me-75`} /> : null}
                    {t(title) || null}
                </div>
                <Flex align="center" justify={"end"} className="pt-sm-0">
                    {extraHeader ? (
                        extraHeader 
                    ) : null}
                    {confirmButton.showOnTop && isDirty ? (
                        <CustomAlerts
                            color="info"
                            controlled
                            testId="alert-unsaved-changes"
                            className="w-max d-none d-md-block mb-0"
                            body={
                                <span className="fw-bolder">
                                    {" "}
                                    <i className="mdi mdi-alert" /> {t("You have unsaved changes")}
                                </span>
                            }/>
                    ) : null}
                    {confirmButton.showOnTop && confirmButton.txt ? (
                        <LoadingButton
                            testId="common-modal-btn-apply"
                            subject={subject}
                            className="align-items-center"
                            icon={confirmButton.icon}
                            action={action}
                            color={confirmButton.color}
                            loading={confirmButton.loading}
                            onClick={confirmButton.onClick}
                            disabled={confirmButton.disabled}
                            text={confirmButton.txt}/>
                    ) : null}
                    {!hideClose ? <>
                        <Button
                            type="button"
                            data-cy="modal-close-btn"
                            onClick={() => handleModal()}
                            className="p-50 align-items-center"
                            color="transparent">
                            <i className="mdi mdi-close font-medium-5" />
                        </Button> </> : null }
                </Flex>
            </div>
            <ModalBody data-cy="modal-body" className={modalBodyClassName}>{loading ? <ComponentSpinner/> : body}</ModalBody>
            {confirmButton.txt && !confirmButton.showOnTop ? (
                <ModalFooter data-cy="modal-footer" className="p-75">
                    <Flex align="center" justify={"end"} className="w-100">
                        {!confirmButton.showOnTop && isDirty ? (
                            <CustomAlerts
                                color="info"
                                controlled
                                testId="alert-unsaved-changes"
                                alertBodyClass="p-25"
                                className="w-max  d-none d-md-block mb-0"
                                body={
                                    <span className="fw-bolder">
                                        {" "}
                                        <i className="mdi mdi-alert" /> {t("You have unsaved changes")}
                                    </span>
                                }/>
                        ) : null}
                        {extraFooterItems ? extraFooterItems : null}
                        {confirmButton.txt && !confirmButton.showOnTop ? (
                            <LoadingButton
                                testId="common-modal-btn-apply"
                                subject={subject}
                                className="align-items-center"
                                action={action}
                                icon={confirmButton.icon}
                                color={confirmButton.color}
                                loading={confirmButton.loading}
                                onClick={confirmButton.onClick}
                                disabled={confirmButton.disabled}
                                text={confirmButton.txt}/>
                        ) : null}
                    </Flex>
                </ModalFooter>
            ) : null}
        </Modal>
    );
};

export default CommonModal;